import routesImporting from '@/router/routes/routesImporting.js'
import routesStatic from '@/router/routes/routesStatic.js'
import routesFundraisersPublic from '@/router/routes/routesFundraisersPublic.js'
import routesDashboard from '@/router/routes/routesDashboard.js'
import routesFundraisers from '@/router/routes/routesFundraisers.js'
import routesOrganizations from '@/router/routes/routesOrganizations.js'
import routesTeams from '@/router/routes/routesTeams.js'
import routesDonations from '@/router/routes/routesDonations.js'
import routesFundraiserPagesPublic from '@/router/routes/routesFundraiserPagesPublic.js'
import routesTeamsPublic from '@/router/routes/routesTeamsPublic.js'
import HomePage from '@/pages/HomePage.vue'
import PublicNaked from '@/layouts/PublicNaked.vue'
import HomePageLayout from '@/layouts/HomePageLayout.vue'
import NotFound from '@/pages/NotFound.vue'
import routesSupportRequests from '@/router/routes/routesSupportRequests.js'
import routesIntegrations from '@/router/routes/routesIntegrations.js'
import routesPlatformSettings from '@/router/routes/routesPlatformSettings.js'

// Keep dashboard components out of the public entry bundle.
const BackendPages = () => import('@/layouts/BackendPages.vue')
const SendEmailNotificationsPage = () => import('@/pages/simple-blaster/SendEmailNotificationsPage.vue')

const DashboardPage = () => import('@/pages/dashboard/DashboardPage.vue')
const ReportsPage = () => import('@/pages/reports/ReportsPage.vue')
const AccessDenied = () => import('@/pages/AccessDenied.vue')
const ConfirmPassword = () => import('@/pages/auth/ConfirmPassword.vue')
const UserPage = () => import('@/pages/UserPage.vue')
const Register = () => import('@/pages/auth/Register.vue')
const VerifyEmail = () => import('@/pages/auth/VerifyEmail.vue')
const TwoFactorChallenge = () => import('@/pages/auth/TwoFactorChallenge.vue')
const ForgotPassword = () => import('@/pages/auth/ForgotPassword.vue')
const ResetPassword = () => import('@/pages/auth/ResetPassword.vue')
const Login = () => import('@/pages/auth/Login.vue')
const GettingStartedPage = () => import('@/pages/getting-started/GettingStartedPage.vue')

export default [
  { path: '/', name: 'Home', component: HomePage, meta: { layout: HomePageLayout } },
  ...routesStatic,
  ...routesFundraisersPublic,
  ...routesFundraiserPagesPublic,
  ...routesTeamsPublic,
  ...routesIntegrations,
  {
    name: 'AccessDenied',
    path: '/access-denied',
    component: AccessDenied
  },
  {
    path: '/dashboard',
    component: BackendPages,
    meta: { requiresAuth: true },
    children: [
      { path: '', name: 'DashboardPage', component: DashboardPage },
      { path: 'reports', name: 'ReportsPage', component: ReportsPage },
      { path: 'getting-started', name: 'GettingStartedPage', component: GettingStartedPage },
      {
        path: 'send-email-notifications-to-organizations',
        name: 'send-email-notifications-to-organizations-page',
        component: SendEmailNotificationsPage,
      },
      { path: 'user', name: 'User', component: UserPage },
      { path: 'confirm-password', name: 'ConfirmPassword', component: ConfirmPassword },
      ...routesDashboard,
      ...routesFundraisers,
      ...routesOrganizations,
      ...routesTeams,
      ...routesDonations,
      ...routesImporting,
      ...routesSupportRequests,
      ...routesPlatformSettings,
    ]
  },
  {
    path: '/auth',
    redirect: '/login',
    component: PublicNaked,
    meta: { isGuest: true },
    children: [
      { path: '/register', name: 'Register', component: Register },
      { path: '/login', name: 'Login', component: Login },
      { path: '/verify-email', name: 'VerifyEmail', component: VerifyEmail },
      { path: '/two-factor-challenge', name: 'TwoFactorChallenge', component: TwoFactorChallenge },
      { path: '/forgot-password', name: 'ForgotPassword', component: ForgotPassword },
      { path: '/reset-password/:token', name: 'ResetPassword', component: ResetPassword }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: NotFound
  }
]
